var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sscw-container sscw-flex-column",attrs:{"id":"stepLoading"}},[_c('img',{staticClass:"loading-animation",attrs:{"src":require("../../../../static/Loading_RuhestandPlus-3.gif"),"alt":"Loading"}})])
}]

export { render, staticRenderFns }